import React, { useEffect, useState } from "react";
import api from "../../api";
import { useNavigate, useParams } from "react-router-dom";
import Steps from "../../components/Steps";
import FormNewPatient from "../../components/FormNewPatient";
import { useMediaQuery } from "../../hooks/useMediaQuery";
import PatientModuleHeader from "../../components/patients/layout/PatientModuleHeader";
import PatientModuleLayout from "../../components/patients/layout/PatientModuleLayout";

const radio = [
    { id: "male", default: true, label: "Masculino", value: "1" },
    { id: "female", default: false, label: "Femenino", value: "2" },
];

export default function PatientNewPage() {
    const [sidebarOpen, setSidebarOpen] = useState(false);
    const [sidebarOpenDesktop, setSidebarOpenDesktop] = useState(true);
    const [loading, setLoading] = useState(true);
    const [loadingSubmit, setLoadingSubmit] = useState(false);
    const [cities, setCities] = useState([]);
    const [insurances, setInsurances] = useState([]);
    const [tab, setTab] = useState("DATOS PERSONALES");
    const navigate = useNavigate();
    const [patient, setPatient] = useState({
        phoneNumbers: [],
        dm: false,
        hta: false,
        aler: false,
        gl: false,
        strabismus: false,
        glaucoma: false,
        cataractSurgery: false,
        glaucomaSurgery: false,
        refractiveSurgery: false,
        motherDm: false,
        motherHta: false,
        motherGlaucoma: false,
        fatherDm: false,
        fatherHta: false,
        fatherGlaucoma: false,
        siblingsDm: false,
        siblingsHta: false,
        siblingsGlaucoma: false,
        otherDm: false,
        otherHta: false,
        otherGlaucoma: false,
        registrationDate: new Date().toISOString().split("T")[0],
    });
    const [error, setError] = useState();
    const { idPatient } = useParams();
    const [steps, setStep] = useState([
        { id: "01", name: "DATOS PERSONALES", status: "current" },
        { id: "02", name: "ANTECEDENTES", status: "upcoming" },
    ]);
    const [pages, setPages] = useState([
        { name: "Pacientes", href: "/patients", current: false },
        { name: "Registro del paciente", href: `#`, current: true },
    ]);
    const isDesktop = useMediaQuery("(min-width: 1024px)");

    useEffect(() => {
        if (isDesktop) {
            setSidebarOpen(false);
        }
    }, [isDesktop]);

    useEffect(() => {
        if (tab === "DATOS PERSONALES") {
            setStep([
                { id: "01", name: "DATOS PERSONALES", status: "current" },
                { id: "02", name: "ANTECEDENTES", status: "upcoming" },
            ]);
        } else {
            setStep([
                { id: "01", name: "DATOS PERSONALES", status: "complete" },
                { id: "02", name: "ANTECEDENTES", status: "current" },
            ]);
        }
    }, [tab]);

    const handleChange = (field, value) =>
        setPatient((prev) => ({ ...prev, [field]: value }));
    const handlePhones = (field, value) => {
        let obj = patient.phoneNumbers ? patient.phoneNumbers.slice() : [];
        obj.push({ number: value });
        setPatient((prev) => ({ ...prev, phoneNumbers: obj }));
    };

    const removePhone = (indx) => {
        let auxPhones = patient.phoneNumbers.slice(0);
        auxPhones.splice(indx, 1);
        setPatient((prev) => ({ ...prev, phoneNumbers: auxPhones }));
    };

    const handleError = (field, value) =>
        setError((prev) => ({ ...prev, [field]: value }));

    useEffect(() => {
        api.insurances.getMulti().then((res) => {
            setInsurances(res);
            api.cities.getMulti().then((response) => {
                setCities(response);
                if (idPatient) {
                    api.patients.getOne(idPatient).then((data) => {
                        setPatient({
                            ...data,
                            city: response.find(
                                (element) => element.id === data.city
                            ),
                            insurance: res.find(
                                (element) => element.id === data.insurance
                            ),
                        });
                        setPages([
                            {
                                name: "Pacientes",
                                href: "/patients",
                                current: false,
                            },
                            {
                                name: `${data.firstName} ${data.lastName}`,
                                href: `/patients/${idPatient}`,
                                current: false,
                            },
                            {
                                name: "Registro del paciente",
                                href: `#`,
                                current: true,
                            },
                        ]);
                        setLoading(false);
                    });
                } else {
                    handleChange(
                        "city",
                        response.find((element) => element.name === "Asuncion")
                    );
                    setLoading(false);
                }
            });
        });
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const handleSubmit = (event) => {
        event.preventDefault();
        setLoadingSubmit(true);
        if (idPatient) {
            api.patients
                .update(idPatient, {
                    ...patient,
                    confirmedData: true,
                    city:
                        typeof patient.city === "object"
                            ? patient.city.id
                            : patient.city,
                    insurance:patient.insurance === undefined || patient.insurance === null
                            ? null
                            : typeof patient.insurance === "object"
                            ? patient.insurance.id
                            : patient.insurance,
                    birthdate:
                        patient.birthdate === "" ? null : patient.birthdate,
                })
                .then((response) => {
                    console.log(response);
                    setLoadingSubmit(false);
                    navigate(`/patients/${response.id}`);
                })
                .catch((error) => {
                    setError(error.message);
                    setLoadingSubmit(false);
                    setTab("DATOS PERSONALES");
                });
        } else {
            api.patients
                .create({
                    ...patient,
                    confirmedData: true,
                    city:
                        typeof patient.city === "object"
                            ? patient.city.id
                            : patient.city,
                    insurance:
                        typeof patient.insurance === "object"
                            ? patient.insurance.id
                            : patient.insurance,
                })
                .then((response) => {
                    setLoadingSubmit(false);
                    navigate(`/patients/${response.id}`);
                })
                .catch((error) => {
                    setError(error.message);
                    setLoadingSubmit(false);
                    setTab("DATOS PERSONALES");
                });
        }
    };

    const handleSidebarToggle = () => {
        if (isDesktop) {
            setSidebarOpenDesktop(!sidebarOpenDesktop);
            return;
        }
        setSidebarOpen(!sidebarOpen);
    };

    return (
        <PatientModuleLayout
            sidebarOpen={sidebarOpen}
            setSidebarOpen={setSidebarOpen}
            sidebarOpenDesktop={sidebarOpenDesktop}
            loading={loading}
            header={
                <PatientModuleHeader
                    pages={pages}
                    onToggleSidebar={handleSidebarToggle}
                    mobileBackTo="/patients"
                    mobileBackLabel="Pacientes"
                />
            }
        >
            <div className="mx-auto flex w-full max-w-6xl flex-col gap-5 px-4 py-4 lg:px-6 lg:py-6">
                <section className="rounded-[28px] border border-slate-200 bg-white p-4 shadow-sm dark:border-slate-800 dark:bg-slate-950 sm:p-5">
                    <div className="flex flex-col gap-4 lg:flex-row lg:items-center lg:justify-between">
                        <div>
                            <p className="text-xs font-semibold uppercase tracking-[0.18em] text-slate-500 dark:text-slate-400">
                                Pacientes
                            </p>
                            <h1 className="mt-1 text-xl font-semibold text-slate-900 dark:text-white sm:text-2xl">
                                {idPatient ? "Editar paciente" : "Nuevo paciente"}
                            </h1>
                        </div>
                        <div className="w-full max-w-3xl">
                            <Steps setTab={setTab} steps={steps} />
                        </div>
                    </div>
                </section>

                <div className="w-full">
                    <div className="w-full">
                        <FormNewPatient
                            handleChange={handleChange}
                            patient={patient}
                            radio={radio}
                            insurances={insurances}
                            cities={cities}
                            error={error}
                            handlePhones={handlePhones}
                            removePhone={removePhone}
                            loadingSubmit={loadingSubmit}
                            handleSubmit={handleSubmit}
                            handleError={handleError}
                            tab={tab}
                            setTab={setTab}
                            setInsurances={setInsurances}
                        />
                    </div>
                </div>
            </div>
        </PatientModuleLayout>
    );
}
